// منابع واحدِ نقش‌ها — هم‌راستا با بک‌اند (accounts/apps.py)
// STAFF_ROLE_GROUPS: گروه‌های پرسنلی که به پنل staff/ادمین دسترسی دارند.
// اگر روزی گروه جدید اضافه شود، فقط همین‌جا (و بک‌اند) را تغییر بده.
export const ROLE_GROUPS = ['admin', 'support', 'seller', 'courier', 'pike'];
export const STAFF_ROLE_GROUPS = ['admin', 'support', 'courier', 'pike'];

// فاز P3 (بند ۴.۶): تشخیص نقش فقط از همین فایل. تا پیش از این هر صفحه یک
// نسخهٔ دستی از این منطق داشت و نسخه‌ها با هم فرق داشتند: بعضی‌ها فقط
// `user_type` را می‌خواندند (NotificationContext، Profile.isSeller) و بعضی
// `roles[]` را. چون API نقش را در `roles[]` (گروه‌های جنگو) می‌فرستد و
// `user_type` می‌تواند «customer» بماند (مثلاً پیک؛ ر.ک. NOTE بک‌اند)،
// آن نسخه‌ها پیک/پیکی را «عضو» و پشتیبانیِ با user_type=customer را غیرپرسنل
// می‌دیدند. `user_type`/`role` فقط برای blob های قدیمیِ localStorage نگه
// داشته می‌شوند و مرجع اصلی `roles[]` است.

/** فهرست نرمال‌شدهٔ نقش‌های کاربر (roles[] + user_type/role قدیمی، بدون تکرار). */
export const extractRoles = (user) => {
  if (!user) return [];
  const raw = Array.isArray(user.roles) ? user.roles : [];
  const legacy = [user.user_type, user.role];
  const out = [];
  const seen = new Set();
  for (const v of [...raw, ...legacy]) {
    if (!v && v !== 0) continue;
    const s = String(v).trim().toLowerCase();
    if (!s || seen.has(s)) continue;
    seen.add(s);
    out.push(s);
  }
  return out;
};

/** آیا کاربر نقش `name` را دارد؟ (names_case_insensitive، null-safe) */
export const hasRole = (user, name) => {
  const s = String(name ?? '').trim().toLowerCase();
  if (!s) return false;
  return extractRoles(user).includes(s);
};

/** آیا کاربر هر-کدام از نقش‌های `names` است؟ */
export const hasAnyRole = (user, names) =>
  (Array.isArray(names) ? names : []).some((n) => hasRole(user, n));

/**
 * پرسنل = گروه نقشِ پرسنلی (admin/support/courier/pike) یا حسابِ staff/superuser.
 * `is_staff`/`is_superuser` ملاکِ خودشان هستند: superuser بدون هیچ گروهی هم
 * پرسنل است (همان گاردی که StaffRoute دارد).
 */
export const isStaffUser = (user) => {
  if (!user) return false;
  if (user.is_superuser === true || user.is_staff === true) return true;
  return STAFF_ROLE_GROUPS.some((r) => hasRole(user, r));
};

/** پیک/پیکی — از گروه نقش، با fallback به فلگ‌های حساب (کاربر قدیمی). */
export const isCourierUser = (user) => hasRole(user, 'courier') || user?.is_courier === true;
export const isPikeUser = (user) => hasRole(user, 'pike') || user?.is_pike === true;
